import React from 'react';
import { motion } from 'framer-motion';

interface HeaderProps {
  logoUrl?: string;
  title?: string;
  isVisible?: boolean;
}

const Header: React.FC<HeaderProps> = ({
  logoUrl,
  title = 'Walky',
  isVisible = true
}) => {
  if (!isVisible) return null;

  return (
    <motion.header
      className="flex gap-2 sm:gap-3 mobile-padding pt-safe py-3 sm:py-4 items-center h-[8vh] sm:h-[10vh] bg-white shadow-sm landscape-compact"
      initial={{ y: -50, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      {logoUrl && (
        <img
          src={logoUrl}
          alt="Logo"
          className="w-8 h-8 sm:w-10 sm:h-10 rounded-lg object-cover flex-shrink-0"
        />
      )}
      <span className="font-[Agency] text-base-responsive sm:text-lg lg:text-xl text-black truncate">
        {title}
      </span>
    </motion.header>
  );
};

export default Header;
